module.exports = __webpack_public_path__ + "static/DasaSans-Light-dd60f85ef70b760ace4748cf9871257f.ttf";